import React, {
    useContext, useMemo, useState,
} from 'react';

import css from './dishButtonRounded.module.scss';
import { BasketContext } from '../BasketProvider';
import { NYGiftContext } from '../NYGiftContext';
import './dots.scss';

export const DishButtonRounded = (
    {
        id,
        portion,
        dishCountStep,
        maxPortion = 9,
        onClickAddToBasket = () => { },
        hasStaticPositon = false,
        className,
        buttonsDisabled = false,
        // NY2024
        giftWrapId = undefined,
        realm = 'ANY',
        isChecked = null,

        discountPriceWithStep,
        originalPriceWithStep,
        price,
    },
) => {
    const { updateBasket } = useContext(BasketContext);
    // NY2024
    /* FRNT-3400 ПОДАРОЧНАЯ УПАКОВКА */
    const {
        removeHeadItem,
        addHeadItem,
        // itemsList,
        getItemsListById,
        isGiftItem,
    } = useContext(NYGiftContext);

    const [transitionDialogState, setTransitionDialogState] = useState('exited');
    const { itemsList } = getItemsListById(id, giftWrapId);

    const getItemsCount = (id, giftId) => {
        if (!giftId) {
            return {
                commonItemsCount: 0, modedItemsCount: 0,
            };
        }

        const commonItemsCount = itemsList.filter((item) => item === id).length;
        const modedItemsCount = itemsList.filter((item) => item === giftId).length;
        return { commonItemsCount, modedItemsCount };
    };

    const { commonItemsCount, modedItemsCount } = getItemsCount(id, giftWrapId);

    const portionsCountWith_gift_dish = useMemo(() => {
        if (isGiftItem(id)) {
            // eslint-disable-next-line arrow-body-style
            return modedItemsCount + commonItemsCount;
        }
        const portionsCount = (portion > maxPortion)
            ? maxPortion
            : portion;
        return portionsCount;
    }, [portion, id, maxPortion, modedItemsCount, commonItemsCount, isGiftItem]);

    const handleClickIncrease = (e) => {
        e.stopPropagation();
        if (portion >= maxPortion) return;
        // console.log(lastItemId);

        // FRNT-3400 Упаковка
        if (giftWrapId && realm === 'ANY') {
            setTransitionDialogState('entering');
        } else if (realm === 'DISH_DETAILS') {
            const commonPortionCount = commonItemsCount + dishCountStep;
            const modedPortionCount = modedItemsCount + dishCountStep;
            const portionCount = isChecked ? modedPortionCount : commonPortionCount;

            updateBasket({
                dishId: isChecked ? giftWrapId : id,
                portions: portionCount,
                onCompletedCallback: () => {
                    addHeadItem(isChecked ? giftWrapId : id);
                },
            });
        } else {
            const nextCount = portion + dishCountStep;
            onClickAddToBasket({ id, portions: nextCount });
            updateBasket({ dishId: id, portions: nextCount });
        }
    };

    const handleClickDecrease = (e) => {
        e.stopPropagation();
        // FRNT-3400 Упаковка
        if (giftWrapId) {
            const lastId = removeHeadItem(giftWrapId);
            const nextCountById = isGiftItem(giftWrapId) ? modedItemsCount : commonItemsCount;
            updateBasket({ dishId: lastId, portions: nextCountById - dishCountStep });
        } else {
            const nextCount = portion - dishCountStep;
            if (nextCount < 0) return;
            updateBasket({ dishId: id, portions: nextCount });
        }
    };

    const { discountPriceWithGift, priceWithGift } = useMemo(() => {
        if (giftWrapId) {
            const { isGiftItemSelected } = getItemsListById(id);
            return {
                originalPriceWithGift: !isGiftItemSelected ? originalPriceWithStep : Number(originalPriceWithStep) + 100,
                discountPriceWithGift: !isGiftItemSelected ? discountPriceWithStep : Number(discountPriceWithStep) + 100,
                priceWithGift: !isGiftItemSelected ? price : Number(price) + 100,
            };
        }

        return {
            originalPriceWithGift: originalPriceWithStep,
            discountPriceWithGift: discountPriceWithStep,
            priceWithGift: price,
        };
    }, [getItemsListById, giftWrapId, id, discountPriceWithStep, originalPriceWithStep, price]);

    const isAdded = portionsCountWith_gift_dish > 0;
    const firstPortionLine = discountPriceWithGift;
    const displayPriceText = isAdded
        ? priceWithGift
        : firstPortionLine;

    return (
        <div>
            <div
                className="dishButtonRoundedRoot"
                style={{
                    opacity: isAdded ? 1 : 0,
                    transform: isAdded ? 'translateX(0%)' : 'translateX(110%)',
                }}
            >
                <button
                    type="button"
                    className="dishButtonRounded decrease"
                    onClick={handleClickDecrease}
                    disabled={buttonsDisabled}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M2.5 7H12.5" stroke="#848484" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                <div className="dishButtonRoundedPriceContainer">
                    <div className="dishButtonRoundedPriceText">
                        {displayPriceText}
                        <span className="dishButtonRoundedPriceTextRub"> ₽</span>
                    </div>
                    <div className="dishButtonRoundedPortionsCount">
                        <svg style={{ display: 'inline' }} width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path
                                d="M10 4L4 10M4 4L10 10"
                                stroke="#B7B7B7"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        {' '}
                        {portionsCountWith_gift_dish}
                    </div>
                </div>
                <button
                    type="button"
                    className="dishButtonRounded increase"
                    onClick={handleClickIncrease}
                    disabled={buttonsDisabled}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M2 7H12M7 2V12" stroke="#848484" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className="dishButtonRoundedSingleButtonRoot" style={{ opacity: isAdded ? 0 : 1 }}>
                <button
                    type="button"
                    className="dishButtonRounded increase"
                    onClick={handleClickIncrease}
                    disabled={buttonsDisabled}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M2 7H12M7 2V12" stroke="#848484" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    );
};
